import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Wrench } from 'lucide-react';

export default function Terminos() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 text-slate-300" data-testid="terminos-page">
      <div className="max-w-3xl mx-auto px-4 py-12">
        <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-slate-500 hover:text-slate-300 text-sm mb-8">
          <ArrowLeft className="w-4 h-4" /> Volver
        </button>

        <div className="flex items-center gap-2 mb-8">
          <Wrench className="w-6 h-6 text-amber-500" />
          <span className="font-barlow text-lg font-bold text-amber-500 uppercase">Talleres PRO</span>
        </div>

        <h1 className="font-barlow text-3xl font-bold text-slate-50 uppercase mb-8">Terminos y Condiciones</h1>

        <div className="prose prose-invert prose-sm max-w-none space-y-6 text-slate-400 leading-relaxed">
          <p><strong className="text-slate-200">Ultima actualizacion:</strong> {new Date().toLocaleDateString('es-MX', { day: '2-digit', month: 'long', year: 'numeric' })}</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">1. Aceptacion de los terminos</h2>
          <p>Al registrarse y utilizar Talleres PRO, usted acepta estos terminos y condiciones en su totalidad. Si no esta de acuerdo, no utilice la plataforma.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">2. Descripcion del servicio</h2>
          <p>Talleres PRO es una plataforma de gestion para talleres mecanicos y autolavados que permite administrar ordenes de trabajo, clientes, vehiculos, pagos, contabilidad y mas a traves de un navegador web.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">3. Periodo de prueba</h2>
          <p>Al registrarse, se le otorga un periodo de prueba gratuito de 7 dias con acceso completo a todas las funciones. Al finalizar el periodo de prueba, debera realizar un pago para continuar utilizando el servicio. El pago puede realizarse mediante deposito bancario o tarjeta de credito/debito.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">4. Pagos y suscripciones</h2>
          <p>Los pagos pueden realizarse de forma manual (deposito o transferencia bancaria) o automatica (tarjeta de credito/debito). En caso de cobro automatico, se realizara el cargo mensual a su tarjeta registrada. Usted puede cancelar el cobro automatico en cualquier momento desde su panel de configuracion.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">5. Suspension del servicio</h2>
          <p>Si no se recibe el pago correspondiente al finalizar el periodo de prueba o la suscripcion activa, el acceso a la plataforma sera suspendido temporalmente. Sus datos se mantendran almacenados durante 90 dias. Para reactivar su cuenta, debera realizar el pago pendiente.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">6. Propiedad de los datos</h2>
          <p>Usted es propietario de todos los datos que registre en la plataforma (clientes, vehiculos, ordenes, pagos, etc.). Talleres PRO no reclamara propiedad sobre su informacion comercial.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">7. Responsabilidades del usuario</h2>
          <p>El usuario es responsable de mantener la confidencialidad de sus credenciales de acceso, de la veracidad de la informacion registrada y del uso adecuado de la plataforma conforme a las leyes aplicables.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">8. Limitacion de responsabilidad</h2>
          <p>Talleres PRO no sera responsable por perdidas de datos causadas por el usuario, interrupciones del servicio por causas de fuerza mayor, ni por el uso inadecuado de la plataforma.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">9. Modificaciones</h2>
          <p>Nos reservamos el derecho de modificar estos terminos en cualquier momento. Los cambios seran notificados a traves de la plataforma con al menos 15 dias de anticipacion.</p>

          <h2 className="text-lg font-bold text-slate-200 font-barlow uppercase">10. Contacto</h2>
          <p>Para cualquier duda o aclaracion sobre estos terminos, puede contactarnos a traves de la plataforma o por correo electronico.</p>
        </div>
      </div>
    </div>
  );
}
